import React, {Component} from 'react';

import Logo from './logo';
import Utils from './utils';

class Header extends Component {

    render() {
        const {noUserMenu} = this.props;
        return (
            <div className="foHeader">
                <Logo/>
                { !noUserMenu && <Utils/>}
            </div>
        )
    };

}

export default Header;


// WEBPACK FOOTER //
// ./src/app/components/header/index.js